<template>
    <div class="newUisetting">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <!-- 标题 -->
                <span class="font-sz24">施工质量问题管理</span>
                <div class="head-text fr-mat-top-4">
                    <el-input v-model="searchword" style="width: 200px;margin-right: 15px;" placeholder="请输入标题搜索"
                        suffix-icon="el-icon-search" @input="getKeyworld()">
                    </el-input>
                    <el-button type="primary" @click="addauthority">人员权限设置</el-button>
                    <el-button type="primary" @click="overTimeChange">超时提醒设置</el-button>
                    <el-button type="danger" @click="deleteinfos">删除</el-button>
                </div>
            </div>
            <el-container>
                <!-- 这里是侧边栏-->
                <div class="mar-top20">
                    <el-aside width="200px" class="elAside" style="height: 600px;overflow: auto;">
                        <zTreeYX :zNodes="zNodes" @getData="(ids) => { treeids = ids; GetFeedbackList() }"
                            @addZtree="addZtree" @delZtree="delZtree" @EditName="EditName" @addFileZtree="addFileZtree"
                            :options="{
                                id: 'id',
                                pid: 'parentid',
                                label: 'tname',
                                zTreeId: 'PdeptTree',
                                delType: {
                                    add: true,
                                    update: true,
                                    del: true,
                                    addFile: true,
                                },
                            }" ref="zTree" />
                    </el-aside>
                </div>
                <el-main>
                    <div class="rygl-table">
                        <el-row class="FCC" style="justify-content: flex-start;">
                            <div>问题状态：</div>
                            <el-select v-model="questionValue" placeholder="请选择" @change="questionValueChange">
                                <el-option v-for="item in questionOptions" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-row>
                        <el-table align="center" class="mar-top20 table width100" v-loading="loading"
                            :data="feedbackList" height="70vh" @selection-change="handleSelectionChange2">
                            <el-table-column align="center" type="selection" width="55"></el-table-column>
                            <el-table-column align="center" type="index" label="序号"></el-table-column>
                            <el-table-column align="center" prop="title" label="问题标题" width="300">
                                <template slot-scope="scope">
                                    <el-tooltip class="item" :disabled="scope.row.title.length > 20 ? false : true"
                                        effect="dark" :content="scope.row.title" placement="top-start">
                                        <el-button size="small" type="text" @click="lookQuestion(scope.row)">{{
                                            scope.row.title.length > 20 ? scope.row.title.substr(0, 20) :
                                                scope.row.title
                                        }}</el-button>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="strstatus" label="问题状态">
                                <template slot-scope="scope">
                                    <el-button size="small" type="text"
                                        :style="{ color: scope.row.status === 0 || scope.row.status === 3 ? 'red' : scope.row.status === 1 ? '#9EF3E8' : scope.row.status === 2 ? '#CACACA' : '#000' }">{{
                                            scope.row.strstatus }}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="prde03" label="指定处理人">
                                <template slot-scope="scope">
                                    <el-button size="small" type="text" class="wirte">
                                        {{scope.row.replayusers != null ? (scope.row.replayusers.map((el) =>
                                            el.user04)).join() : '请设置处理人员'}}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="username" label="发起人"></el-table-column>
                            <!-- <el-table-column align="center" prop="creatdate" label="发起时间"></el-table-column> -->
                            <el-table-column align="center" label="操作" width="250">
                                <template slot-scope="scope">
                                    <el-button size="small" :type="scope.row.istop != 0 ? 'danger' : 'primary'" plain
                                        @click="TopOne(scope.row.id)">{{ scope.row.istop != 0 ? '取消置顶' : '置顶'
                                        }}</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination class="mar-top20" align="right" @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" :current-page="pagenum" :page-sizes="[10, 50, 100]"
                        :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
                        :total="total"></el-pagination>
                </el-main>
            </el-container>
            <!-- 预览 -->
            <el-dialog :close-on-click-modal="false" title="施工质量问题单" top="1%" :visible.sync="ShowQuestion" width="70%"
                height="50%">
                <el-form :model="SGForm" :rules="SGRule" label-width="160px" ref="addSGForm"
                    style="padding-right: 60px;height:650px;overflow-y: auto;">
                    <el-form-item label="问题标题：" prop="title">
                        <div>{{ SGForm.title }}</div>
                    </el-form-item>
                    <el-row style="padding:0px">
                        <el-col :span="6">
                            <el-form-item label="问题状态：" prop="strstatus">
                                <div>{{ SGForm.strstatus }}</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <!-- <el-form-item label="关闭时间：" prop="">
                                <div>{{ SGForm.colsetime == "0001/01/01 00:00:00" ? "" : SGForm.colsetime }}</div>
                            </el-form-item> -->
                        </el-col>
                    </el-row>
                    <el-row style="padding:0px;margin-top: 20px;" v-for="(item, index) in SGForm.disposelsit"
                        :key="index">
                        <el-row style="padding:0px">
                            <el-col :span="6">
                                <el-form-item :label="index == 0 ? '发起人：' : '追问人：'" prop="">
                                    <div>{{ item.fbusername }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <!-- <el-form-item :label="index == 0 ? '发起时间：' : '追问时间：'" prop="">
                                    <div>{{ item.fbdate }}</div>
                                </el-form-item> -->
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="处理人：" prop="">
                                    <div>{{ item.disusername }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <!-- <el-form-item label="处理时间：" prop="">
                                    <div>{{ item.disposedate == "0001/01/01 00:00:00" ? "" : item.disposedate }}</div>
                                </el-form-item> -->
                            </el-col>
                        </el-row>
                        <el-col :span="12">
                            <el-form-item label="问题描述：" prop="fbcontent">
                                <div style="width: 100%;max-height: 110px;overflow-y: auto;">
                                    <p>{{ item.fbcontent }}</p>
                                </div>
                            </el-form-item>
                            <el-form-item label="图片：" prop="fbfiles">
                                <el-carousel height="200px" style="margin-top: 10px;">
                                    <el-carousel-item v-for="(file) in (item.fbfiles.split(','))" :key="file">
                                        <el-image style="width: 100%; height: 100%;border-radius: 4px;"
                                            :src="actionUrl + file" fit="fill"></el-image>
                                    </el-carousel-item>
                                </el-carousel>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="处理情况：" prop="disposecontent">
                                <el-input v-if="!questionDisable && index + 1 == SGForm.disposelsit.length"
                                    type="textarea" v-model="item.disposecontent"
                                    :autosize="{ minRows: 5, maxRows: 10 }" maxlength="500" show-word-limit></el-input>
                                <div v-else style="width: 100%;max-height: 110px;overflow-y: auto;">
                                    <p>{{ item.disposecontent }}</p>
                                </div>
                            </el-form-item>
                            <el-form-item label="图片：" prop="fileList" ref="imageFile">
                                <el-upload v-if="item.disposefiles == null" ref="upload" v-model="fileList" multiple
                                    class="upload-demo" accept=".jpg,.jpeg,.png,.JPG,.JPEG" :action="actionUrl"
                                    :on-change="handleChange1" :before-upload="beforeUpload">
                                    <el-button size="medium">点击选择文件</el-button>
                                </el-upload>
                                <el-carousel v-else height="200px" style="margin-top: 10px;">
                                    <el-carousel-item
                                        v-for="(file1) in (item.disposefiles != null ? item.disposefiles.split(',') : [])"
                                        :key="file1">
                                        <el-image style="width: 100%; height: 100%;border-radius: 4px;"
                                            :src="actionUrl + file1" fit="fill"></el-image>
                                    </el-carousel-item>
                                </el-carousel>
                            </el-form-item>
                        </el-col>
                        <el-col :span="2" :offset="22"
                            v-if="submitStatus == false && index + 1 == SGForm.disposelsit.length">
                            <el-button type="primary" style="width:100%"
                                @click="questionBtn(item, false, index)">确定</el-button>
                        </el-col>
                        <el-col :span="4" :offset="20"
                            v-if="replayStatus == true && index + 1 == SGForm.disposelsit.length">
                            <div style="float: right;">
                                <el-button @click="continueBtn()">不合格</el-button>
                                <el-button type="primary" v-show="zwStatus == true"
                                    @click="questionBtn(item, true, index)">确认关闭</el-button>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12" v-if="zwStatus == false">
                            <el-form-item label="问题描述：" prop="">
                                <el-input type="textarea" v-model="newFeedback.fbcontent"
                                    :autosize="{ minRows: 4, maxRows: 10 }" maxlength="500" show-word-limit></el-input>
                            </el-form-item>
                            <el-form-item label="图片：" prop="" ref="imageFile">
                                <el-upload ref="upload" v-model="fileList" multiple class="upload-demo"
                                    accept=".jpg,.jpeg,.png,.JPG,.JPEG" :action="actionUrl" :on-change="handleChange1"
                                    :before-upload="beforeUpload">
                                    <el-button size="medium">点击选择文件</el-button>
                                </el-upload>
                            </el-form-item>
                            <el-col :span="3" :offset="21">
                                <el-button style="margin-top:10px;width: 100%" type="primary"
                                    @click="questionBtn1()">确定</el-button>
                            </el-col>
                        </el-col>
                    </el-row>
                </el-form>
            </el-dialog>
            <!-- 超时提醒设置 -->
            <el-dialog :close-on-click-modal="true" title="超时提醒设置" :visible.sync="timeShow" width="50%" height="50%">
                <el-form :model="numForm" :rules="rules" label-width="180px" ref="addForm1" style="margin: 5% 25%;">
                    <el-form-item label="请设置超时提醒时间：" class="mar-top40" prop="num">
                        <el-input-number v-model="numForm.num" @change="handleChangeTime" :min="1" :max="72"
                            label="设置超时提醒时间:"></el-input-number> 小时
                    </el-form-item>
                </el-form>
                <el-row>
                    <el-col :span="2" :offset="22">
                        <el-button type="primary" @click="timeBtn('addForm1')">确定</el-button>
                    </el-col>
                </el-row>
            </el-dialog>
            <!-- 权限设定 -->
            <el-dialog :close-on-click-modal="false" title="权限设定" :visible.sync="invitation" width="50%" height="50%">
                <el-form :model="invitationForm" label-width="180px" style="margin: 40px;">
                    <el-form-item label="发起/删除权限：">
                        <el-select filterable class="width100" v-model="upOrdelUser" multiple placeholder="请选择人员">
                            <el-option v-for="item in optionsUser" :key="item.user01" :label="item.user04"
                                :value="item.user01"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="处理权限：" class="mar-top40">
                        <el-select filterable class="width100" v-model="replyUser" multiple placeholder="请选择人员">
                            <el-option v-for="item in optionsUser" :key="item.user01" :label="item.user04"
                                :value="item.user01"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-row>
                    <el-col :span="2" :offset="22">
                        <el-button type="primary" @click="authorityBtn">确定</el-button>
                    </el-col>
                </el-row>
            </el-dialog>
            <!-- 新增 -->
            <el-dialog :close-on-click-modal="false" title="新增施工质量问题" :visible.sync="ADDFileShow" width="50%"
                height="50%">
                <el-form :model="QuestionForm" :rules="QuestionRule" ref="addquestionForm" label-width="100px"
                    class="demo-ruleForm">
                    <el-form-item label="问题标题：" prop="title">
                        <el-input v-model="QuestionForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="问题描述：" prop="strcount">
                        <el-input type="textarea" v-model="QuestionForm.strcount"
                            :autosize="{ minRows: 4, maxRows: 10 }" maxlength="500" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="图片：" prop="fileList" ref="imageFile">
                        <el-upload ref="upload" v-model="QuestionForm.fileList" multiple class="upload-demo"
                            accept=".jpg,.jpeg,.png,.JPG,.JPEG" :action="actionUrl" :on-change="handleChange"
                            :before-upload="beforeUpload">
                            <el-button size="medium">点击选择文件</el-button>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div class="txt-cen-pa20-0">
                    <el-button @click="submitQuestion('addquestionForm')" type="primary">确定</el-button>
                </div>
            </el-dialog>
        </el-card>
    </div>
</template>

<script>
import zTreeYX from "@//components/zTreeYX.vue";
import ckediter4 from "@/components/ck.vue";
import {
    GetMember,
    GetywproTreeList,
    Insertywprotree,
    Updateywprotree,
    Deleteywprotree,
    GetYWProUserAuth,
    AddOrUpdateYWProUserAuth,
    GetYWProOutTimeSet,
    UpdateYWProOutTimeSet,
    GetYwFeedbackList,
    AddYwFeedback,
    DelYwFeedback,
    SetProjectFbTop,
    YWFbAskedAndReply
} from "@/setAxios.js";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
    name: "userManagement",
    data() {
        return {
            actionUrl: this.$store.state.baseUrl,
            searchword: "",
            loading: false,
            total: 0,
            pagesize: 10,
            pagenum: 1,
            addDialogFormVisible: false,
            invitation: false,
            addForm1: {},
            addSGForm: {},
            optionsUser: [],
            invitationForm: {},
            upOrdelUser: null,
            replyUser: null,
            multipleSelection2: [],
            ids: "null",
            zNodes: null,
            ADDFileShow: false,
            fileList: [],
            feedbackList: [],
            idTree: null,
            questionValue: '-1',
            questionOptions: [{
                value: '-1',
                label: '全部'
            }, {
                value: '0',
                label: '待回复'
            }, {
                value: '1',
                label: '已回复待确认'
            }, {
                value: '2',
                label: '已关闭'
            }, {
                value: '3',
                label: '已超时'
            }],
            timeShow: false,

            numForm: {
                num: 48,
            },
            rules: {
                num: [
                    { required: true, message: '请设置超时提醒时间', trigger: 'blur' },
                ],
            },
            QuestionForm: {
                title: '',
                strcount: '',
                fileList: []
            },
            QuestionRule: {
                title: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
                strcount: [
                    { required: true, message: '请输入', trigger: 'blur' },
                ],
                fileList: [
                    {
                        validator: (rule, value, callback) => {
                            const valid = value.length > 0
                            if (valid) {
                                return callback()
                            } else {
                                return callback(new Error(rule.message))
                            }
                        }, required: true, message: '请上传文件',
                    }
                ],
            },

            //质量问题预览
            SGForm: {
                strstatus: '',
                title: '',
                username: '',
                creatdate: ''
            },
            SGRule: {
                strstatus: [
                    { required: true, message: '请输入问题状态', trigger: 'blur' },
                ],
                title: [
                    { required: true, message: '请输入问题标签：', trigger: 'blur' },
                ],
                username: [
                    { required: true, message: '请输入发起人', trigger: 'blur' },
                ],
                creatdate: [
                    { required: true, message: '请输入创建时间', trigger: 'blur' },
                ],
                // disposecontent: [
                //     { required: true, message: '请输入处理情况描述', trigger: 'blur' },
                // ],
                // fileList: [
                //     {
                //         validator: (rule, value, callback) => {
                //             const valid = value.length > 0
                //             if (valid) {
                //                 return callback()
                //             } else {
                //                 return callback(new Error(rule.message))
                //             }
                //         }, required: true, message: '请上传文件',
                //     }
                // ],
            },
            ShowQuestion: false,
            questionDisable: false,
            replayStatus: false,//回复状态
            submitStatus: false,//确认状态
            zwStatus: true,//追问状态
            newFeedback: {
                fbcontent: '',
                fileList: []
            },
            PersonId: 0,
            treeids: null
        };
    },
    components: { zTreeYX, ckediter4 },
    methods: {
        questionValueChange(value) {
            this.questionValue = value;
            this.GetFeedbackList()
        },
        // 超时设置
        async overTimeChange() {
            let res = await GetYWProOutTimeSet({
                params: { xid: this.$store.state.xid, type: 5 },
            });
            this.numForm.id = res.Data != null ? res.Data.id : 0;
            this.numForm.num = res.Data != null ? res.Data.outtime : 48;
            this.timeShow = true;
        },
        timeBtn(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = {
                        id: this.numForm.id,
                        projectid: this.$store.state.xid,
                        outtime: this.numForm.num,
                        type: 5,
                    };
                    UpdateYWProOutTimeSet(params).then((res) => {
                        res.Code == 1
                            ? this.$message.success("设置成功！")
                            : this.$message.error("设置失败！");
                        this.timeShow = false;
                    });
                } else {
                    this.$message.error("验证失败！");
                    return false;
                }
            });
        },
        handleChangeTime(value) {
            this.numForm.num = value;
        },
        // 人员权限设置
        addauthority() {
            this.invitation = true;
            let params = {
                seachword: "",
                id: this.$store.state.xid,
                cid: localStorage.getItem("pid"),
                bid: "null",
                pageIndex: 1,
                pageSize: 999999,
            };
            GetMember({ params }).then((res) => {
                this.optionsUser = res.Data.list;
            });
        },
        // 获取项目模块人员权限
        GetYWProUserAuthUser() {
            let params = {
                xid: this.$store.state.xid,
                type: 7
            }
            GetYWProUserAuth({ params }).then((res) => {
                if (res.Data) {
                    if (res.Data) {
                        this.upOrdelUser = res.Data.insertuids != null ? res.Data.insertuids.split(',').map(Number) : null;
                        this.replyUser = res.Data.replyuids ? res.Data.replyuids.split(',').map(Number) : null;
                        this.PersonId = res.Data.id
                    }
                }
            });
        },
        authorityBtn() {
            let params = {
                id: this.PersonId,
                projectid: localStorage.getItem("xid"),
                insertuids: this.upOrdelUser != null ? this.upOrdelUser.join(",") : null,
                downloaduids: null,
                replyuids: this.replyUser != null ? this.replyUser.join(",") : null,
                type: 7,
                createuserid: localStorage.getItem("id")
            }
            AddOrUpdateYWProUserAuth(params).then((res) => {
                if (res.Code != 0) {
                    this.$message({
                        type: "success",
                        message: "设置成功",
                    });
                    this.invitation = false;
                    this.GetywproTree();
                    this.GetFeedbackList();
                }
                else {
                    this.$message({
                        type: "warning",
                        message: "信息有误或未选择",
                    });
                }
            });
        },
        beforeUpload(file) {
            var index = file.name.lastIndexOf(".");
            var suffix = file.name.substring(index + 1);
            var suffixs = ["jpg", "jpeg", "png", "JPG", "JPEG"];
            if (suffixs.indexOf(suffix) == -1) {
                this.$message({
                    message: "上传文件只能是 jpg、jpeg、png、JPG、JPEG格式!",
                    type: "warning",
                });
                return false;
            }
            return true;
        },
        handleChange(file, fileList) {
            // 写法并不影响清除form表单样式，只要保证图片上传完成（如果不加入等待参数，样式还未生效，也无法清除，会有异常）
            this.$nextTick(() => {//等待照片上传完成，
                this.$refs.imageFile.clearValidate('fileList')
            })
            this.QuestionForm.fileList = fileList;
        },
        handleChange1(file, fileList) {
            // 写法并不影响清除form表单样式，只要保证图片上传完成（如果不加入等待参数，样式还未生效，也无法清除，会有异常）
            // this.$nextTick(() => {//等待照片上传完成，
            //     this.$refs.imageFile.clearValidate('fileList')
            // })
            this.fileList = fileList;
        },
        questionBtn(data, status, index) {
            let result = false;
            this.SGForm.disposelsit.forEach((el) => {
                // 处理情况
                if (el.disposecontent != null) {
                    // 上传地址
                    if (el.disposefiles != null || this.fileList.length > 0) {
                        result = true
                    } else {
                        this.$message.error('请上传文件!');
                        result = false
                    }
                    // 都不为空
                    return result
                } else {
                    // 有空数据
                    this.$message.error('请填写完成数据!')
                    result = false
                }
                return result
            })
            // result, true为不空,false为空
            if (result) {
                let params = {
                    fbid: this.SGForm.id,
                    projectid: this.$store.state.xid,
                    type: 3,
                    isclose: status,
                    disposeid: data.id,
                    strcontent: !status ? data.disposecontent : ''
                }
                let fd = new FormData();
                for (var key in params) {
                    fd.append(key, params[key]);
                }
                this.fileList.forEach((file) => {
                    fd.append('filses', file.raw);
                })
                YWFbAskedAndReply(fd).then((res) => {
                    if (res.Code != 0) {
                        this.GetFeedbackList();
                        this.$message.success("操作成功");
                        this.ShowQuestion = false;
                        this.replayStatus = true;
                        this.questionDisable = true;
                        this.fileList = []
                        this.$refs.upload.clearFiles();
                    } else {
                        this.$message.error(res.Message);
                    }
                })
            }
        },
        continueBtn() {
            this.newFeedback = {
                id: 0,
                feedbackid: this.SGForm.id,
                fbcontent: "",
            }
            this.zwStatus = false
        },
        questionBtn1() {
            if (this.newFeedback.fbcontent == "") {
                this.$message.error('请填写完成数据!');
                return false
            }
            if (this.fileList.length == 0) {
                this.$message.error('请上传文件!');
                return false
            }
            let params = {
                fbid: this.newFeedback.feedbackid,
                projectid: this.$store.state.xid,
                type: 3,
                isclose: false,
                disposeid: 0,
                strcontent: this.newFeedback.fbcontent
            }
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            this.fileList.forEach((file) => {
                fd.append('filses', file.raw);
            })
            YWFbAskedAndReply(fd).then((res) => {
                if (res.Code != 0) {
                    this.$message.success("操作成功");
                    this.ShowQuestion = false;
                    this.zwStatus = true;
                    this.fileList = [];
                    this.$refs.upload.clearFiles();
                    this.GetFeedbackList();
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        // 高亮
        tableRowClassName({ row, rowIndex }) {
            if (row.comu05 != 1) {
                return 'success-row';
            }
            return '';
        },
        // 做反馈操作
        lookQuestion(data) {
            this.ShowQuestion = true;
            this.SGForm = data;
            //状态回复设置
            if (data.status === 0) {//
                this.replayStatus = false;
                this.questionDisable = false;
                this.submitStatus = false;
            } else if (data.status === 1) {//回复待确认
                this.replayStatus = true;
                this.questionDisable = true;
                this.submitStatus = true;
                this.zwStatus = true;
            } else if (data.status === 2) {//已关闭
                this.submitStatus = true;
                this.questionDisable = true;
                this.replayStatus = false
            }
        },
        // 新增树节点
        async addZtree(id) {
            let params = {
                id: 0,
                projectid: localStorage.getItem("xid"),
                tname: "新建节点" + Math.floor(Math.random() * 100),
                parentid: id,
                orderid: null,
                type: 4,
                createuserid: localStorage.getItem("id"),
            };
            let res = await Insertywprotree(params);
            this.$refs.zTree.add(res);
        },
        async delZtree(ids) {
            if (ids.split(',').length > 1) {
                this.$message({
                    message: "请选择一个节点进行删除",
                    type: "warning",
                });
                return false;
            }
            let params = { id: ids };
            let res = await Deleteywprotree(params);
            this.$refs.zTree.del(res);
        },
        async EditName(id, name, pid, data) {
            let params = {
                id,
                projectid: data.projectid,
                tname: name,
                parentid: data.parentid,
                orderid: data.orderid,
                type: data.type,
                createuserid: data.createuserid
            };
            let res = await Updateywprotree(params);
            this.$message.success("编辑成功");
        },
        async addFileZtree(id, data) {
            if (this.replyUser != null && this.replyUser.length < 0) {
                this.$message.warning('请设置处理人员')
            } else {
                this.ADDFileShow = true;
                this.idTree = data.id;
            }

        },
        // 文件树
        GetywproTree() {
            this.loading = true;
            GetywproTreeList({ params: { xid: this.$store.state.xid, type: 4 } }).then((res) => {
                this.zNodes = res.Data;
                this.loading = false;
            });
        },
        handleSelectionChange2(val) {
            this.multipleSelection2 = val;
        },
        // 获取反馈列表
        async GetFeedbackList() {
            let params = {
                searchword: this.searchword,
                projectid: this.$store.state.xid,
                type: 3,
                status: this.questionValue,
                pageindex: this.pagenum,
                pagesize: this.pagesize,
                treeid: this.treeids ? this.treeids : 0,
            };
            let fd = new FormData();
            for (var key in params) {
                fd.append(key, params[key]);
            }
            let res = await GetYwFeedbackList(fd)
            if (res.Code != 0) {
                this.$message.closeAll()
                this.$message.error(res.Message);
                return false;
            }
            this.feedbackList = res.Data.length > 0 ? res.Data : [];
            this.total = res.Count;
        },
        // 新增施工质量问题
        submitQuestion(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let fd = new FormData();
                    this.QuestionForm.fileList.forEach((file) => {
                        fd.append('filses', file.raw);
                    })
                    fd.append("projectid", this.$store.state.xid);
                    fd.append("type", 3);
                    fd.append("fileId", 0);
                    fd.append("treeid", this.idTree);
                    fd.append("title", this.QuestionForm.title);
                    fd.append("strcount", this.QuestionForm.strcount);
                    AddYwFeedback(fd).then((res) => {
                        if (res.Code != 0) {
                            this.$message.success("上传成功");
                            this.QuestionForm = {
                                title: '',
                                strcount: '',
                                fileList: []
                            };
                            this.ADDFileShow = false;
                            this.$refs.upload.clearFiles();
                            this.GetFeedbackList();
                        } else {
                            this.$message.error(res.Message);
                        }
                    })
                } else {
                    this.$message.error('验证失败！')
                    return false;
                }
            });
        },

        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },

        //批量删除
        deleteinfos() {
            if (this.multipleSelection2.length == 0) {
                this.$message({
                    type: "warning",
                    message: "请选择删除内容!",
                });
            } else {
                this.$confirm("此操作将移除所选用户, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        let ids = "",
                            _split = "";
                        this.multipleSelection2.forEach((v) => {
                            ids += _split + v.id;
                            _split = ",";
                        });
                        let params = {
                            ids: ids,
                        };
                        DelYwFeedback(params).then((res) => {
                            if (res.Code > 0) {
                                this.$message({
                                    type: "success",
                                    message: "移除成功!",
                                });
                                this.GetFeedbackList();
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消操作",
                        });
                        this.loading = false;
                    });
            }
        },
        getKeyworld(keyworld) {
            this.GetFeedbackList()
        },
        //   置顶
        async TopOne(id) {
            let params = { id };
            let res = await SetProjectFbTop(params);
            res.Code != 0 ? this.$message.success('操作成功') : this.$message.error('操作失败')
            this.GetFeedbackList();
        },
        handleSizeChange(val) {
            this.pagesize = val;
            this.GetFeedbackList();
        },
        handleCurrentChange(val) {
            this.pagenum = val;
            this.GetFeedbackList();
        },
    },
    watch() { },
    created() {
    },
    mounted() {
        this.GetywproTree();
        this.GetYWProUserAuthUser();
        this.GetFeedbackList();
    },
};
</script>

<style lang="less" scoped>
div#PdeptRemenu {
    position: fixed;
    visibility: hidden;
    top: 0;
    width: 60px;
    background-color: #35a5db;
    padding: 4px;
    border-radius: 3px;
    overflow: auto;
    border: 1px solid #eee;
}

div#PdeptRemenu ul {
    margin: 0px;
    padding: 0px;
}

div#PdeptRemenu ul li {
    font-size: 12px;
    line-height: 20px;
    margin: 0px;
    padding: 0px;
    cursor: pointer;
    list-style: none outside none; //取消样式
    background-color: rgba(255, 255, 255, 0);
    padding-left: 3px;
    margin: 1px auto;
    color: white;
    border-radius: 3px;
    letter-spacing: 1px;
}

div#PdeptRemenu ul li:hover {
    background: #eee;
    color: #000000;
}

#PdeptTree {
    height: 500px;
}

.zTreeDiv {
    overflow: auto;
}

.ztree li span {
    // color: #fff;
    line-height: 21px;
    margin-right: 2px;
}

.userManagement .search-input {
    width: 300px;
}

/deep/ #UpdateProUserOpen1 .el-input__inner::-webkit-input-placeholder {
    color: #000000;
}
</style>
<style scoped lang="less">
/* 新增 */
.font-sz24 {
    font-size: 24px;
}

.fr-mat-top-4 {
    float: right;
    margin-top: -4px;
}

.mar-t80 {
    margin-right: 80px;
}

.mar-top20 {
    margin-top: 20px;
}

.elAside {
    /* border: 1px solid #dcdfe6; */
    border-radius: 4px;
    text-align: center;
}

.width100 {
    width: 100%;
}

.mar-top40 {
    margin-top: 40px;
}

.mar00-20-30 {
    margin: 0 0 20px 30%;
}

.mar-r80 {
    margin-right: 80px;
}

.txt-cen-pa20-0 {
    text-align: right;
    padding: 20px 0;
}

.width90 {
    width: 90%;
}

.text-cen {
    text-align: center;
}

/deep/.el-table .success-row {
    background: #f0f9eb;
}
</style>